/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "almaAppApi",
            "endpoint": "https://lah2nwk9k0.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:223288fb-d15c-4378-a96a-cc8877c61936",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_7Vh0QYY7M",
    "aws_user_pools_web_client_id": "6ilqaoctdnplmgudgdfqho5lpd",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "almarituals143254-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
